import { Component, ComponentFactoryResolver, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConsoleService } from '@ng-select/ng-select/lib/console.service';
import { VideoAlbumService } from '../../../../../app/shared/API-Service/services/video-album.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Image } from '../../../../../images/images'
import { BaseComponent } from 'src/app/shared/components/base/base.component';


@Component({
  selector: 'app-view-video-album',
  templateUrl: './view-video-album.component.html',
  styleUrls: ['./view-video-album.component.css']
})
export class ViewVideoAlbumComponent extends BaseComponent implements OnInit {
  videoalbums:object [] = [];
  img : string = Image;
  constructor(private _VideoAlbumService:VideoAlbumService,private _Router:Router) { super()}

  ngOnInit(): void {
    this.getvideoalbums();
  }
  pageChanged(event: any){
    this.pageNumber = event.page;// -1 * pageSize;
    this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
   this.getvideoalbums();
  }

  getvideoalbums(){
    this._VideoAlbumService.GetVideoAlbumPaged(this.pager).subscribe((res) => {
      this.videoalbums = res.data.items
      this.totalCount=res.data.totalCount
    },(err)=>{
    },() =>{
    });
  }
  update(data){
    this._VideoAlbumService.Data.next(data);
    this._Router.navigate(['/content/admin/InsertVideoAlbum']);
    }
    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this._VideoAlbumService.DeleteVideoAlbum(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getvideoalbums();
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
          })
        }
      }) 
    }
}
